import { useMediaQuery, useTheme } from "@mui/material";
import { IS_WEB } from "../utils/runtime";

/**
 * Возвращает `true`, если сейчас нужно рисовать «десктопный» layout:
 *   • runtime = web (не Telegram Mini App — там всегда мобильная разметка);
 *   • экран шире `md` breakpoint'а (по умолчанию 900px в MUI).
 *
 * В Telegram Mini App всегда возвращает `false`, даже если mini app открыт
 * на desktop-клиенте Telegram (там ширина ограничена самой Telegram-обёрткой).
 */
export function useDesktopLayout(): boolean {
  const theme = useTheme();
  // >= md (900px). Хорошо ложится на большинство ноутбуков; на планшетах
  // (768px) остаётся привычная мобильная одноколоночная раскладка.
  const isWide = useMediaQuery(theme.breakpoints.up("md"));
  return IS_WEB && isWide;
}
